import {
  CalculatedBalancesGroupedTwiceArray,
  CalculatedBalanceCollection,
  ScenarioBalanceParams,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { signal } from "@angular/core";

export class ScenarioBalanceByTimeAndAccountsCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "ScenarioBalanceByTimeAndAccounts";
  protected calculations: CalculatedBalancesGroupedTwiceArray = [];

  protected _balances = signal<CalculatedBalancesGroupedTwiceArray>([]);
  readonly balances = this._balances.asReadonly();

  async updateCalculations(parameters: ScenarioBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    const promises: Promise<Record<string, Record<string, number>>>[] = [];
    for (const transactions of parameters.scenarioTransactions) {
      promises.push(
        this.getBalanceByTimeAccounts(
          parameters.webWorkerQueue,
          transactions,
          parameters.period.startDate,
          parameters.period.endDate,
          parameters.group.granularity,
        ),
      );
    }
    const results: Record<number, Record<string, number>>[] = await Promise.all(promises);
    if (isStale()) {
      return;
    }
    this.setBalances(results);
  }

  getCalculations(): CalculatedBalancesGroupedTwiceArray {
    return this.calculations;
  }

  protected clearCalculations(): void {
    this.calculations = [];
    this._balances.set(null);
  }

  triggerChanges(): void {}

  private setBalances(
    balancesByTimeAccountsArray: Array<Record<number, Record<string, number>>>,
  ): void {
    this.calculations = [];

    for (const balancesByTimeAccounts of balancesByTimeAccountsArray) {
      const balanceMap = new Map();
      for (const [time, balancesByAccount] of Object.entries(balancesByTimeAccounts)) {
        const balancesByAccountMap = new Map(Object.entries(balancesByAccount));
        balanceMap.set(time, balancesByAccountMap);
      }
      this.calculations.push(balanceMap);
    }

    this._balances.set(this.calculations);
  }
}
